import type { MultiItemUsageRestrictionWarningDialogRequest } from './multiItemUsageRestrictionWarningDialogRequest';
import { requestDialog } from './requestDialog';

export function showMultiItemUsageRestrictionWarningDialog(req: MultiItemUsageRestrictionWarningDialogRequest) {
  requestDialog(req, () => import('@mimir/web/pages/item/components/MultiItemUsageRestrictionWarningDialog.vue'));
}
